import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainDrawerService, DrawerContent } from './main-drawer.service';
import { FuseDrawerModule } from '@fuse/components/drawer';
import { MatAnchor, MatButton, MatIconButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDrawer, MatDrawerContainer, MatDrawerContent } from '@angular/material/sidenav';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import {
  AccordionQuoteRequestViewComponent,
} from '@sbd-doug-frontend/shared/lib/shared-components/accordion-quote-request-view/accordion-quote-request-view.component';
import { DrawerMenuItem } from '@sbd-account-portal/app/modules/main-fuse-drawer/menus-buttons-template.types';
import { Address } from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import { MatDivider } from '@angular/material/divider';
import {
  CommonDrawerFooterComponent
} from '@sbd-doug-frontend/shared/lib/shared-components/common-drawer-footer/common-drawer-footer.component';

@Component({
  selector: 'sbd-doug-frontend-main-drawer',
  standalone: true,
  imports: [CommonModule, FuseDrawerModule, MatProgressSpinner, AccordionQuoteRequestViewComponent, MatToolbar, MatAnchor, MatDivider, MatIconButton, MatIcon, CommonDrawerFooterComponent],
  templateUrl: './main-drawer.component.html',
  styleUrl: './main-drawer.component.scss',
})
export class MainDrawerComponent implements OnInit, OnDestroy {
  private drawerService = inject(MainDrawerService);

  readonly isOpen = this.drawerService.isOpen;
  readonly content = this.drawerService.content;
  readonly loading = this.drawerService.loading;
  readonly title = this.drawerService.title;
  readonly subtitle = this.drawerService.subtitle;
  readonly showCloseButton = this.drawerService.showCloseButton;
  readonly allowOutsideClick = this.drawerService.allowOutsideClick;
  readonly position = this.drawerService.position;
  readonly config = this.drawerService.config;
  readonly context = this.drawerService.context;
  readonly hasContent = this.drawerService.hasContent;
  readonly drawerClasses = this.drawerService.drawerClasses;
  readonly mode = this.drawerService.mode;
  readonly hasBackdrop = this.drawerService.hasBackdrop;
  readonly disableClose = this.drawerService.disableClose;
  readonly canClose = this.drawerService.canClose;
  readonly sizeType = this.drawerService.sizeType;
  quoteSelectionChanged = this.drawerService.quoteSelectionChanged;


  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  /**
   * Handle drawer close event
   */
  onClose(): void {
    this.drawerService.onDrawerClosed();
  }

  /**
   * Handle button clicks from drawer config
   */
  onButtonClick(buttonId: string, buttonData?: any): void {
    console.log('Button clicked:', buttonId, buttonData);
  }

  /**
   * Check if content is of specific type
   */
  isContentType(type: string): boolean {
    return this.content()?.type === type;
  }

  /**
   * Handle drawer opened event
   */
  onDrawerOpened($event: boolean): void {
    if ($event) {
      this.drawerService.onDrawerOpened();
    } else {
      this.drawerService.onDrawerClosed();
    }
  }

  /**
   * Handle drawer closed event
   */
  onDrawerClosed(): void {
    this.drawerService.onDrawerClosed();
  }

  quoteSelectionEvent($event: any): void {
    this.drawerService.quoteSelectionChanged.set($event)
  }

}
